import { render, staticRenderFns } from "./InteractiveVocab.vue?vue&type=template&id=133ba7d2&scoped=true&"
import script from "./InteractiveVocab.vue?vue&type=script&lang=js&"
export * from "./InteractiveVocab.vue?vue&type=script&lang=js&"
import style0 from "./InteractiveVocab.vue?vue&type=style&index=0&id=133ba7d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133ba7d2",
  null
  
)

export default component.exports